import CsatByDeviceAndDateWidget from './CsatByDeviceAndDateWidget';
export default CsatByDeviceAndDateWidget;



// WEBPACK FOOTER //
// ./src/components/widgetTypes/components/CsatByDeviceAndDateWidget/index.js